AmCharts.translations.ru = {"monthNames":["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],"shortMonthNames":["Янв","Фев","Мар","Апр","Май","Июн","Июл","Авг","Сен","Окт","Ноя","Дек"],"dayNames":["Воскресенье","Понедельник","Вторник","Среда","Четверг","Пятница","Суббота"],"shortDayNames":["Вск","Пнд","Втр","Срд","Чтв","Птн","Сбт"],"zoomOutText":"Показать все"}


//////////////////
// WEBPACK FOOTER
// ./~/amcharts3/amcharts/lang/ru.js
// module id = 269
// module chunks = 0